// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input_calendar.mid[data-v-5f06eea8], .input_calendar.mid input[data-v-5f06eea8] {\n    width: 200px;\n}\ndiv.input_error .inp_cal[data-v-5f06eea8] {\n  border: 1px solid #f2084f !important;\n}\n.impp[data-v-5f06eea8] {\n  position: absolute;\n}\n.imp[data-v-5f06eea8] {\n  position: relative;\n  top: 0px;\n  left: -220px;\n  z-index: 99999;\n}\n", ""]);
// Exports
module.exports = exports;
